import React from 'react';
import { LayoutDashboard, Building2, FileText, DollarSign, Users, Settings } from 'lucide-react';
interface SidebarProps {
  currentPage: string;
  onPageChange: (page: any) => void;
}
export function Sidebar({
  currentPage,
  onPageChange
}: SidebarProps) {
  const menuItems = [{
    id: 'sites',
    label: 'Chantiers',
    icon: <Building2 size={20} data-id="element-193" />
  }, {
    id: 'contacts',
    label: 'Contacts',
    icon: <Users size={20} data-id="element-194" />
  }];
  return <aside className="w-64 bg-gray-900 text-white flex flex-col" data-id="element-195">
      <div className="p-6 border-b border-gray-800" data-id="element-196">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8TqFKdC4LW2Hc8J9kPHYEt/Sans_titre_9.png" alt="Action Progex" className="w-full h-auto mb-2" data-id="element-197" />
        <p className="text-sm text-gray-400 mt-2" data-id="element-198">Gestion de chantiers</p>
      </div>
      <nav className="flex-1 p-4 space-y-1" data-id="element-199">
        {menuItems.map(item => <button key={item.id} onClick={() => onPageChange(item.id)} className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${currentPage === item.id ? 'bg-red-600 text-white' : 'text-gray-300 hover:bg-gray-800'}`} data-id="element-200">
            {item.icon}
            <span className="font-medium" data-id="element-201">{item.label}</span>
          </button>)}
      </nav>
      <div className="p-4 border-t border-gray-800" data-id="element-202">
        <button className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-800 transition-colors" data-id="element-203">
          <Settings size={20} data-id="element-204" />
          <span className="font-medium" data-id="element-205">Paramètres</span>
        </button>
      </div>
    </aside>;
}